<template>
  <div class="news-table w-100">
    <h3 class="mb-3">{{ $t("heading") }}</h3>
    <nx-table class="esh-bd-table mt-3" :rows="newsList">
      <nx-table-column
        :title="$t('table.date')"
        data="date"
        v-slot="{ rowData }"
        width="200"
      >
        {{ dateFormatter(rowData.date) }}
      </nx-table-column>
      <nx-table-column
        :title="$t('table.content')"
        data="content"
        v-slot="{ rowData }"
      >
        <span class="table-content" v-html="rowData.content" />
      </nx-table-column>
    </nx-table>
    <UFPaginationNav v-if="newsList.length" class="mt-2" :pagination="pagination" @navigate="updateList($event)" />
  </div>
</template>

<script>
import { UFPaginationNav } from '@unify/uf-pagination';
import { MaintainNewsApi } from '@/api';

export default {
  components: {
    UFPaginationNav
  },
  data() {
    return {
      newsList: [],
      pagination: {
        page: 0,
        size: 5,
        sort: 'date desc'
      }
    };
  },
  async created() {
    await this.updateList();
    setTimeout(() => $('.dataTables_empty').text(this.$t('TableNoData')), 0);
  },
  methods: {
    async updateList(pageable) {
      let params = pageable || this.pagination;
      const { data } = await MaintainNewsApi.getLatestNewstList({...params, language: this.$i18n.locale});
      const { content, pagination } = data
      this.newsList = content.filter(row => row.language === this.$i18n.locale);
      this.pagination = pagination;
    },
    dateFormatter(date) {
      switch(this.$i18n.locale){
        case "en": 
          return moment(date).format('DD MMM YYYY');
        case "zh_hk": 
          return moment(date).locale('zh_hk').format('LL');
        case "zh_cn": 
          return moment(date).locale('zh_cn').format('LL');
        default: 
          return moment(date).format('DD MMM YYYY');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table-content ::v-deep a {
  text-decoration: underline !important;
}
</style>

<i18n src="@/locales/common.locale"></i18n>
<i18n src="@/locales/components/info/InfoNewsTable.json"></i18n>